import { makeStyles, shorthands } from "@fluentui/react-components";

export const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    ...shorthands.gap("20px"),
  },

  firstRow: {
    display: "flex",
    justifyContent: "space-between",
    ...shorthands.gap("20px"),

    "@media (max-width: 514px)": {
      flexWrap: "wrap",
    },
  },

  firstRowItem1: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "31.55%",

    "@media (max-width: 514px)": {
      flexBasis: "100%",
    },
  },

  firstRowItem2: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "66%",

    "@media (max-width: 514px)": {
      flexBasis: "100%",
    },
  },

  secondRow: {
    display: "flex",
    justifyContent: "space-between",
    ...shorthands.gap("20px"),

    "@media (max-width: 769px)": {
      flexWrap: "wrap",
    },
  },

  secondRowItem: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "33%",

    "@media (max-width: 769px)": {
      flexBasis: "100%",
    },
  },

  carousel: {
    width: "unset",
    ...shorthands.padding("0px", "8px", "4px", "8px"),
  },
});
